const SubsectionCard = ({
  title,
  feedbackText,
  score,
  postfix,
  subTitle,
  subContent,
}) => {
  let subtitleClass = "writingGradeSectionSubheader";

  if (!feedbackText) {
    subtitleClass = "writingGradeSectionSubheaderNoFeedback";
  }

  return (
    <div className="writingGradeSectionSubsectionCardContainer">
      <div className="writingGradeSectionSubsectionHeaderContainer">
        <h3 className="writingGradeSectionSubsectionHeader">
          {title} - Score {score} {postfix}
        </h3>
      </div>
      <div className="writingGradeSectionSubsectionBodyContainer">
        {feedbackText && (
          <>
            <h4 className="writingGradeSectionSubsectionTitle">Feedback</h4>
            <p className="writingGradeSectionSubsectionText">{feedbackText}</p>
          </>
        )}
        {subTitle && subContent && (
          <>
            <h4 className={subtitleClass}>{subTitle}</h4>
            <div className="writingGradeSectionSubsectionWrapper">
              {subContent.length > 0 ? (
                subContent.map((detail) => (
                  <div
                    className="writingGradeSectionSubsectionCardContainer"
                    key={`irrelevantDetail-${detail}`}
                  >
                    <div className="writingGradeSectionSubsectionBodyContainer">
                      <p className="writingGradeSectionSubsectionText">
                        {detail}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <div className="writingGradeSectionSubsectionCardContainer">
                  <div className="writingGradeSectionSubsectionBodyContainer">
                    <p className="writingGradeSectionSubsectionText">
                      No {subTitle} Found
                    </p>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        <p className="writingGradeSectionScoreText">Score: {score}</p>
      </div>
    </div>
  );
};

export default SubsectionCard;
